module.exports = {
      id: "close-usage",
      viewBox: "0 0 512.001 512.001",
      url: __webpack_public_path__ + "svg-sprite-3f41b5422aa8d7a50bd372d0b736cd55.svg#close",
      toString: function () {
        return this.url;
      }
    }